import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { deletePost, updatePost } from '@/redux/actions';

const WS_POSTS_BY_HTTP = {
	UPDATE: 'posts/:postID/UPDATE',
	DELETE: 'posts/:postID/DELETE',
};

const PostsSubscriptions = props => {
	const { socket, currentEventId, updatePost, deletePost } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		console.log('⚡️ PostsSubscription Mounted ⚡️');
		socket.emit('posts/:eventID/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		console.log(`🚶‍♂️ PostsSubscription Unmounted 🚶‍♂️`);
		socket.emit('posts/:eventID/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForUpdatePost = () =>
		socket.on(WS_POSTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating post', error);
			else {
				updatePost({ post: data });
				displayMessage('Post updated');
			}
		});

	const listenForDeletePost = () =>
		socket.on(WS_POSTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting post', error);
			else {
				deletePost(data);
				displayMessage('Post deleted');
			}
		});

	const listeners = () => [listenForUpdatePost, listenForDeletePost];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_POSTS_BY_HTTP)}
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	deletePost: postID => dispatch(deletePost(postID)),
	updatePost: post => dispatch(updatePost(post)),
});

export default connect(msp, mdp)(PostsSubscriptions);
